import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { API_ENDPOINTS } from '@framework/utils/endpoints';
import { FilteredItem } from './filtered-item';

export function FilterQueryTags() {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { pathname, query } = router;
  const queryClient = useQueryClient();

  const slugToName = useMemo(() => {
    const map: Record<string, string> = {};
    const collect = (endpoint: string) => {
      for (const [, data] of queryClient.getQueriesData<any>([endpoint])) {
        const pages: any[] = data?.pages ?? (data ? [data] : []);
        for (const page of pages) {
          for (const item of page?.data ?? []) {
            if (item?.slug && item?.name) map[item.slug] = item.name;
          }
        }
      }
    };
    collect(API_ENDPOINTS.CATEGORIES);
    collect(API_ENDPOINTS.TYPE);
    return map;
  }, [query, queryClient]);

  const tags = useMemo(() => {
    if (isEmpty(query)) return null;
    const filteredTags = Object.keys(query)
      .filter((k) => k !== 'slug' && !isEmpty(query[k]))
      .map((k) => query[k] as string);
    if (filteredTags.length === 0) return null;
    return filteredTags.join(',').split(',');
  }, [query]);

  const handleClearFilters = () => {
    const { slug } = query;
    const preservedQuery = slug ? { slug } : {};

    router.push(
      {
        pathname,
        query: preservedQuery,
      },
      undefined,
      { scroll: false },
    );
  };

  return (
    <div
      style={tags ? { marginBottom: '8px' } : { marginBottom: '0px' }}
      className="flex gap-2 items-center flex-wrap"
    >
      {tags && (
        <div className="flex gap-2 flex-wrap">
          {tags.map((v, idx) => (
            <FilteredItem
              itemKey={Object.keys(query).find((k) => query[k]?.includes(v))!}
              itemValue={v}
              label={slugToName[v]}
              key={idx}
              classname="border-none h-7 m-0"
            />
          ))}
        </div>
      )}
      {tags && (
        <button
          onClick={handleClearFilters}
          className="h-7 flex items-center text-sm text-[#C59B66] hover:underline w-auto"
        >
          {t('text-clear-all')}
        </button>
      )}
    </div>
  );
}
